<template>
  <td :class="{'warning-red': value_row.color === 1, 'cell-grey': value_row.color === 2, 'cell-green': value_row.color === 3}" v-if="value_row.type === 0" colspan="12" v-text="value_row.data"></td>
  <td :class="{'warning-red': value_row.color === 1, 'cell-grey': value_row.color === 2, 'cell-green': value_row.color === 3}" v-else-if="value_row.type === 1" rowspan="2" v-text="value_row.data"></td>
  <td :class="{'warning-red': value_row.color === 1, 'cell-grey': value_row.color === 2, 'cell-green': value_row.color === 3}" v-else v-text="value_row.data"></td>
</template>

<script>
export default {
  data () {
    return {
      value_row: {}
    }
  },
  created () {
    this.value_row = this.valueRow
  },
  props: [
    'valueRow'
  ],
  watch: {
    valueRow (value) {
      this.value_row = value
      if (value.color === 1) {
        this.sendError()
      }
    }
  },
  methods: {
    sendError () {
      this.$geb.emit({id: 'error_detected', error: 1})
    }
  }
}
</script>

<style lang="scss" scoped>
  .warning-red {
    color: white;
    background-color: red;
  }

  .cell-grey {
    background-color: grey;
    color: white;
    font-weight: 700;
  }

  .cell-green {
    background-color: lightgreen;
    font-weight: 700;
  }
</style>


// WEBPACK FOOTER //
// src/pages/panel/frontdesk/components/ReportRowEvent.vue